import { render } from "./StrategyStatic.vue?vue&type=template&id=d0236efc&scoped=true"
import script from "./StrategyStatic.vue?vue&type=script&lang=js"
export * from "./StrategyStatic.vue?vue&type=script&lang=js"

import "./StrategyStatic.vue?vue&type=style&index=0&id=d0236efc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0236efc"]])

export default __exports__